import React from 'react'
import IconSystem from "../IconSystem"
import { Text } from "@sqymagma/elements"
import { theme } from "../../utils/themeGet"

export default ({toggleCalendarMenu}) => (

    <Text 
        pt={["7px", null, 0]} pb={["14px", null, 0]}
        as="li" textStyle="label" color="text05" 
        display="inline-flex" alignItems="center"
        mr="16px"
        css={`{
            transition: all ease-out 0.35s;
            cursor: pointer;
            & :hover a { color: ${theme(`color.brand04`)}} }
            & :hover * { fill: ${theme(`color.brand04`)}} }
        }`}
    >
        <IconSystem name="calendar" height="16px" mr="8px" fill="text05"/>
        <Text onClick={toggleCalendarMenu} as="a">
            calendario
        </Text>

    </Text>
)